import { useEffect, useMemo, useState } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import { useQueryResponseLoading } from '../core/QueryResponseProvider'
import customerColumns from './columns/_columns'
// import {Customer} from '../core/_models'
import CustomersListLoading from '../components/loading/CustomersListLoading'
import CustomersListPagination from '../components/pagination/CustomersListPagination'
import { KTCard, KTCardBody } from '../../../../../_template/helpers'
import { useSelector } from 'react-redux'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import CustomersListSearchComponent from '../components/header/CustomersListSearchComponent'
import { useAppDispatch } from '../../../../hooks'
import { getAllFunction } from '../../../../redux/actions/commonCrud'
import * as endpoints from '../../../../../_template/helpers/endpoints'
import * as actionTypes from '../../../../redux/actionTypes'
import TCustomerFilterValues from '../../../../types/TCustomerFilterValues'
import PaginationComponent from '../../../../../_template/layout/components/pagination'

const CustomersTable: React.FC<any> = ({ setCount }) => {
  const customers: ICustomer[] = useSelector(({ users }: { users: UsersState }) => {
    return users.customers
  })
  const totalPages: number = useSelector(({ users }: { users: UsersState }) => {
    return users.totalPages
  })

  const totalItems: number = useSelector(({ users }: { users: UsersState }) => {
    return users.totalItems
  })

  const [filterValues, setFilterValues] = useState<TCustomerFilterValues>()

  const handleChangeValues = (e?: React.ChangeEvent<any>) => {
    if (e) {
      setFilterValues({
        ...filterValues,
        // ...filterObject,
        [e.target.name]: e.target.value,
      })
    } else {
      setFilterValues(undefined)
    }
  }

  const dispatch = useAppDispatch()
  const handleDispatch = () => {
    dispatch(
      getAllFunction(endpoints.customerEndpoint, actionTypes.GET_ALL_CUSTOMERS, filterValues)
    )
  }
  const resetData = () => {
    setFilterValues({ firstName: '', lastName: '', phoneNumber: '', email: '', city: '' })
  }
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => customers, [customers])
  const columns = useMemo(() => customerColumns, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })

  useEffect(() => {
    if (totalItems) {
      setCount(totalItems)
    } else {
      setCount(0)
    }
  }, [totalItems])

  return (
    <KTCard>
      <KTCardBody className='py-4'>
        <div className='d-flex justify-content-between'>
          <div className='w-100'>
            <CustomersListSearchComponent
              resetData={resetData}
              filterValues={filterValues}
              handleChangeValues={handleChangeValues}
              handleDispatch={handleDispatch}
            // eventKey={eventKey}
            />
          </div>
          {/* <div style={{width: '180px'}}>
            <UsersListFilter eventKey={eventKey} />
          </div> */}
        </div>

        <div className='table-responsive'>
          <table
            id='kt_table_users'
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            {...getTableProps()}
          >
            <thead>
              <tr className='text-muted fw-bolder fs-7 text-uppercase gs-0'>
                {headers.map((column: ColumnInstance<ICustomer>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
              </tr>
            </thead>
            <tbody className='text-gray-500 fs-6' {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row: Row<ICustomer>, i) => {
                  prepareRow(row)
                  return <CustomRow row={row} key={`row-${i}-${row.id}`} />
                })
              ) : (
                <tr>
                  <td colSpan={7}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* <CustomersListPagination /> */}
        <PaginationComponent
          values={filterValues}
          setValues={setFilterValues}
          endpoint={endpoints.customerEndpoint}
          actionType={actionTypes.GET_ALL_CUSTOMERS}
          totalPages={totalPages}
        />
        {isLoading && <CustomersListLoading />}
      </KTCardBody>
    </KTCard>
  )
}

export default CustomersTable
